import { config, msg } from 'api';
import { setSuccessMessage, setErrorMessage } from 'apps/notifications/actions/notifications';
import errorHandler from 'lib/utils/errorHandler';
import { pageEventTypes, wa } from 'apps/analytics';

export const PAYPAL_LINKED = 'PAYPAL_LINKED';

export const CLOSE_PAYPAL_ACCOUNT_ALREADY_LINKED_POPUP = 'CLOSE_PAYPAL_ACCOUNT_ALREADY_LINKED_POPUP';
export const OPEN_PAYPAL_ACCOUNT_ALREADY_LINKED_POPUP = 'OPEN_PAYPAL_ACCOUNT_ALREADY_LINKED_POPUP';
export const CLOSE_PAYPAL_LOGIN_NOT_POSSIBLE_ERROR_POPUP = 'CLOSE_PAYPAL_LOGIN_NOT_POSSIBLE_ERROR_POPUP';
export const OPEN_PAYPAL_LOGIN_NOT_POSSIBLE_ERROR_POPUP = 'OPEN_PAYPAL_LOGIN_NOT_POSSIBLE_ERROR_POPUP';
export const SET_PAYPAL = 'SET_PAYPAL';

export function setPaypal(paypalId, isPaypalUser) {
  return {
    type: SET_PAYPAL,
    paypalId,
    isPaypalUser,
  };
}

export function getPaypal() {
  return (dispatch, getState, { network }) =>
    network.get(`${config.apiBasePath}/settings/paypal`)
      .then(response =>
        dispatch(setPaypal(response.email, response.isPayPalUser)),
      )
      .catch(errorHandler);
}

export function openAccountAlreadyLinkedPopup() {
  return { type: OPEN_PAYPAL_ACCOUNT_ALREADY_LINKED_POPUP };
}

export function openPaypalLoginNotPossiblePopup() {
  return { type: OPEN_PAYPAL_LOGIN_NOT_POSSIBLE_ERROR_POPUP };
}

export function closeLoginNotPossiblePopup() {
  return { type: CLOSE_PAYPAL_LOGIN_NOT_POSSIBLE_ERROR_POPUP };
}

export function confirmLoginNotPossiblePopup() {
  wa.triggerPageEvent(pageEventTypes.PAYPAL_SETTINGS_NO_PASSWORD_POPUP_CONFIRMED, {});
  return (dispatch, getState, { network }) => {
    dispatch(closeLoginNotPossiblePopup());
    return network.redirectTo({ to: '/webshop/editLoginDetails.go' });
  };
}

export function closeAccountAlreadyLinkedPopup() {
  wa.triggerPageEvent(pageEventTypes.PAYPAL_SETTINGS_ALREADY_LINKED_POPUP_CLOSED, {});
  return { type: CLOSE_PAYPAL_ACCOUNT_ALREADY_LINKED_POPUP };
}

export function confirmAccountAlreadyLinkedPopup() {
  return { type: CLOSE_PAYPAL_ACCOUNT_ALREADY_LINKED_POPUP };
}

export function unlinkPaypal() {
  wa.triggerPageEvent(pageEventTypes.PAYPAL_SETTINGS_UNLINK_BUTTON_CLICKED);
  return (dispatch, getState, { network }) =>
    network.post(`${config.apiBasePath}/settings/paypal/unlink`)
      .then(() => {
        wa.triggerPageEvent(pageEventTypes.PAYPAL_SETTINGS_SUCCESS_NOTIFICATION_DISPLAYED, { [PAYPAL_LINKED]: false });
        dispatch(setSuccessMessage('Paypal account unlinked'));
        return dispatch(getPaypal());
      })
      .catch((errorResponse) => {
        if (errorResponse.data && errorResponse.data.status === 'LOGIN_NOT_POSSIBLE') {
          wa.triggerPageEvent(pageEventTypes.PAYPAL_SETTINGS_NO_PASSWORD_POPUP_DISPLAYED, {});
          return dispatch(openPaypalLoginNotPossiblePopup());
        }
        wa.triggerPageEvent(pageEventTypes.PAYPAL_SETTINGS_ERROR_NOTIFICATION_DISPLAYED, { [PAYPAL_LINKED]: false });
        return dispatch(setErrorMessage(msg.settings.flashMessage.failure));
      });
}

export function linkPaypal(response) {
  if (response === 'ALREADY_LINKED') {
    return (dispatch) => {
      wa.triggerPageEvent(pageEventTypes.PAYPAL_SETTINGS_ALREADY_LINKED_POPUP_DISPLAYED, {});
      return dispatch(openAccountAlreadyLinkedPopup());
    };
  }
  return (dispatch, getState, { network }) =>
    network.post(`${config.apiBasePath}/settings/paypal/link`, {})
      .then(() => {
        wa.triggerPageEvent(pageEventTypes.PAYPAL_SETTINGS_SUCCESS_NOTIFICATION_DISPLAYED, { [PAYPAL_LINKED]: true });
        dispatch(setSuccessMessage('Paypal account linked'));
        return dispatch(getPaypal());
      })
      .catch(() => {
        wa.triggerPageEvent(pageEventTypes.PAYPAL_SETTINGS_ERROR_NOTIFICATION_DISPLAYED, { [PAYPAL_LINKED]: true });
        return dispatch(setErrorMessage(msg.settings.flashMessage.failure));
      });
}
